import { router } from '@inertiajs/react'
import Button from '../../components/Button'

const ROLE_LABELS = { member: 'Medlem', admin: 'Lagadmin' }

export default function InvitationsShow({ invitation, current_user: currentUser }) {
  function accept() {
    router.post(`/invitations/${invitation.token}/accept`)
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4">
      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-indigo-600">Gosellgo</h1>
        </div>

        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8 text-center">
          <h2 className="text-xl font-bold text-gray-900">Du är inbjuden!</h2>
          <p className="text-gray-600 mt-2">
            Gå med i <strong>{invitation.team_name}</strong> som{' '}
            <strong>{ROLE_LABELS[invitation.role]}</strong>.
          </p>

          {currentUser ? (
            <div className="mt-6">
              <p className="text-sm text-gray-500 mb-4">
                Du är inloggad som <strong>{currentUser.name}</strong>
              </p>
              <Button onClick={accept} className="w-full">
                Acceptera inbjudan
              </Button>
            </div>
          ) : (
            <div className="mt-6 space-y-3">
              <p className="text-sm text-gray-500">Registrera dig eller logga in för att acceptera inbjudan.</p>
              <a
                href={`/sign_up?invitation_token=${invitation.token}`}
                className="block w-full bg-indigo-600 text-white py-2 px-4 rounded-md text-sm font-medium hover:bg-indigo-700 text-center"
              >
                Registrera dig och gå med
              </a>
              <a
                href="/sign_in"
                className="block w-full bg-white border border-gray-300 text-gray-700 py-2 px-4 rounded-md text-sm font-medium hover:bg-gray-50 text-center"
              >
                Logga in
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
